import axios from "axios";
import { useEffect } from "react";

export const useFetchData = (url, setData) => {
    useEffect(() => {
      const fetchData = async () => {
        try {
          const response = await axios.get(url);
          setData(response.data);
        } catch (error) {
          console.error("Error fetching data:", error);
        }
      };
  
      fetchData();
    }, [url, setData]); // Ensure the hook re-fetches if URL or setData changes
  };